import { getArgs } from "../utils";
import api from "./api";

const route = "/online_accesses";

const OnlineAccessesService = {
  getOnlineAccesses: (filters) => api.get(`${route}?${getArgs(filters)}`),
  getSingleOnlineAccess: (online_access_id) =>
    api.get(`${route}/${online_access_id}`),
  postOnlineAccess: (online_access) => api.post(route, { ...online_access }),
  putOnlineAccess: (online_access) => api.put(route, { ...online_access }),
  deleteOnlineAccess: (online_access_id) => api.delete(`${route}/${online_access_id}`),
};

export default OnlineAccessesService;
